import React, { useEffect, useRef, useState } from 'react'
import style from './style.module.sass'
import { useTheme } from '@material-ui/core/styles'
import closeIcon from '../../../../assets/close-circle.svg'
import { useTranslation } from 'react-i18next'
import {
  convertLanguagesToShort, generateBList, isObjectEmpty,
  removeTagMark,
  textClear,
} from '../../../../utils'
import TLServiceComponent from '../../../../contexts/TLServiceComponent'
import ButtonWithPop from '../../Overview/ButtonWithPop'
import nextId from 'react-id-generator'
import { Add, Done } from '@material-ui/icons'
import { useSelector } from 'react-redux'
import ComBotBlue from '../../../../assets/combot-blue.svg'
import ComBotWhite from '../../../../assets/combot-white.svg'
import ComBotBlack from '../../../../assets/combot-black.svg'
import ComBotGray from '../../../../assets/combot-grey.svg'
import { Modal } from '@material-ui/core'
import { useActions } from '../../../../utils/action-helper'
import { analyseSetText} from '../../../../actions'
import ErrorModal from '../ErrorModal'
import config from '../../../../config'
import { checkTick, runOurAi } from '../../../../utils/ai'

export default function LightningModal ({
  selectedText,
  setOpen,
  open,
  editor,
  handleAnalyseFromAi
}) {
  const { t, i18n: { language: i18nLanguage } } = useTranslation()
  const textToAnalyze = selectedText?.getContent()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)

  const token = useSelector(state => state.userData.token)
  const tlService = React.useContext(TLServiceComponent)
  const useBenchmark = useSelector(state => state.analyseData.useBenchmark)
  const benchmarks = useSelector(state => state.userData.benchmarks)
  const taskTypes = useSelector(state => state.userData.taskTypes || [])
  const theme = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)

  const modalRef = React.createRef()
  const { theme: { bgColors, borderColors, colors } } = useTheme()

  const [loading, setLoading] = useState(false)
  const [suggestions, setSuggestions] = useState([])
  const [error, setError] = useState(null)

  const [percent, setPercent] = useState(0)

  const taskIdRef = useRef(0)

  const {
    actionAnalyseSetText
  } = useActions({
    actionAnalyseSetText: analyseSetText
  })

  const ComBot = themeState === config.THEMES_MODES.CONTRAST_DARK ? ComBotWhite : themeState === config.THEMES_MODES.CONTRAST_LIGHT ? ComBotBlack : ComBotBlue

  const doneTick = async (res) => {
    if (res?.length > 0) {
      const textResult = res.replace(/^\n/, '').replace(/\n$/, '')
      setSuggestions(prev => [...prev, textResult])
    }
    setLoading(false)
  }

  const errorTick = async (error) => {
    setLoading(false)
    setError(error)
  }

  const getSuggestions = async (text) => {
    setLoading(true)
    setError(null)
    taskIdRef.current = 0
    setPercent(0)
    setError(null)
    const textResult = textClear(text)

    const filteredTaskTypes = taskTypes.filter(el => el?.function === 'MagicWand')

    // if no benchmark or taskTypes loaded
    if (isObjectEmpty(filteredTaskTypes) || isObjectEmpty(benchmarks)) {
      setError({ text: t('ai_no_enabled_task_types'), header: t('ai_header_no_enabled_task_types')})
      setPercent(0)
      setLoading(false)
      return false
    }

    const [selectedBList, bList] = generateBList(filteredTaskTypes, benchmarks, useBenchmark, 'magicWandPrompt')

    const [taskId, error] = await runOurAi(
      tlService,
      textResult,
      token,
      {},
      '',
      bList,
      selectedBList,
      50000,
      'MagicWand',
      convertLanguagesToShort(i18nLanguage),
      false)

    if (taskId > 0) {
      taskIdRef.current = taskId
      // set tick
      setTimeout(() => checkTick(t, tlService, taskIdRef, token, setPercent, true, doneTick, errorTick, false), 1000)
      return true
    }
    setError({ text: t(error.text), header: t(error.header) })
    setPercent(0)
    setLoading(false)
    return false

  }

  useEffect(() => {
    getSuggestions(textToAnalyze)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleReplaceTheSelectedText = (replacement) => {
    const arrText = replacement.split('\n\n')
    let res = ''
    const parentNode = selectedText?.getStart()

    if (parentNode?.nodeName !== 'P') {
      arrText.forEach((text, ) => {
        res += `<p>${text}</p>`
      })
    } else {
      if (arrText.length > 1) {
        arrText.forEach((text, index) => {
          if (index === 0) {
            res = `${text}</p>`
          } else if (index === arrText.length - 1) {
            res += `<p>${text}`
          } else {
            res += `<p>${text}</p>`
          }
        })
      } else {
        res = replacement
      }
    }
    if (selectedText) {

      const bm = selectedText.getBookmark()
      const rawContent = editor.getBody().innerHTML
      const bookmarkedContent = removeTagMark(rawContent).replaceAll('&nbsp;', ' ').replaceAll('<p><br></p>', '<p></p>')
      const bookSpanStart = `<span data-mce-type="bookmark" id="${bm.id}_start" data-mce-style="overflow:hidden;line-height:0px" style="overflow: hidden; line-height: 0px;"></span>`
      const bookSpanEnd = `<span data-mce-type="bookmark" id="${bm.id}_end" data-mce-style="overflow:hidden;line-height:0px" style="overflow: hidden; line-height: 0px;"></span>`
      const reStart = new RegExp(bookSpanStart)
      const reEnd = new RegExp(bookSpanEnd)
      const startIndex = bookmarkedContent.search(reStart)
      const endIndex = bookmarkedContent.search(reEnd)

      const newText = bookmarkedContent.substring(0, startIndex) + res + bookmarkedContent.substring(endIndex + bookSpanEnd.length)
      actionAnalyseSetText(newText)
      editor.selection.collapse()
      setTimeout(() => handleAnalyseFromAi(editor.getContent()), 200)
    }
  }

  const handleChange = (e, idX) => {
    const { value } = e.target
    const newSuggestions = suggestions.map((s, id) => {
      if (id === idX) {
        return value
      }
      return s
    })
    setSuggestions(newSuggestions)
  }

  if (!open) {
    return null
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      style={{ cursor: 'default', zIndex: 1000 }}>
      <div ref={modalRef} style={{ backgroundColor: bgColors.bgPrimary0 }} className={`${style.mainCont} pb-3`}>
        <ErrorModal error={error} setError={setError}/>
        <div
          style={{ backgroundColor: bgColors.bgPrimary300 }}
          className={`${style.head} d-flex justify-content-between p-1 pl-3 pr-3`}>
          <div className={style.imgdiv}>
            <div className={style.image}><img alt=""
                                              src={ComBot}
                                              width={35}/>
            </div>
          </div>
          <p style={{ color: colors.colorText }}
             className={`m-0 ${style.title}`}>
            {t('analyse_magic_wand-mode')}
          </p>
          <button className={`border-0 bg-transparent pr-1 pl-2`} onClick={() => {
            setOpen(false)
          }} onMouseDown={e => e.stopPropagation()}>
            <img src={closeIcon} alt=""/>
          </button>
        </div>
        <div>
          <div
            className={`${style.fieldPart} d-flex align-items-start justify-content-between pl-3 pr-3 p-1 mt-2 mb-2`}>
            <div style={{ color: colors.colorText }}>
              <b
                dangerouslySetInnerHTML={{
                  __html: textToAnalyze
                }}/>
            </div>
          </div>
          {
            suggestions?.length > 0 &&
            <div className={`${style.rows} ml-3 mr-3 p-1 m-1`}
                 style={{ borderColor: borderColors.borderPrimary100 }}>
              {
                suggestions.map((suggestion, index) => {
                    return (
                      <div
                        className={`${style.row} p-1`} key={index}
                        style={{ borderColor: borderColors.borderPrimary100 }}>
                        <div className={`d-flex align-items-center justify-content-center`}>
                          <div className={style.fieldCont}>
                            <div>
                            <textarea type="text"
                                      rows={5}
                                      style={{
                                        borderColor: borderColors.borderPrimary100,
                                        lineHeight: '1.0em',
                                        width: '540px',
                                        minHeight: '80px',
                                        border: '2px solid lightgray',
                                        outline: 'none',
                                        padding: '10px',
                                        borderRadius: '15px',
                                        margin: '5px',
                                        color: colors.colorText,
                                        background: `linear-gradient(0deg, ${bgColors.bgPrimary0} 3%, ${bgColors.bgPrimary0} 7%)`
                                      }}
                                      value={suggestion.replaceAll('<br>', '\n')}
                                      onMouseDown={e => e.stopPropagation()}
                                      onChange={(e) => handleChange(e, index)}
                            />
                            </div>
                          </div>
                          <div className={`d-flex align-items-center`}
                               style={{
                                 gridGap: '5px',
                                 marginLeft: '10px',
                               }}>
                            <ButtonWithPop
                              text={t('replace here')}
                              typeOfCount={''}
                              onClick={() => {
                                handleReplaceTheSelectedText(suggestion)
                                setOpen(false)
                              }}
                            >
                              <Done
                                key={nextId()}
                                style={{
                                  fill: theme === config.THEMES_MODES.CONTRAST_DARK ? colors.colorIcons : colors.colorProgress100,
                                  height: 24
                                }}/>
                            </ButtonWithPop>
                          </div>
                        </div>

                      </div>
                    )
                  }
                )
              }
            </div>
          }
          {
            !loading && <div className={`d-flex flex-column align-items-start`}
                             style={{
                               gridGap: '5px',
                               margin: '15px',
                             }}>
              <ButtonWithPop
                text={t('analyse_magic_wand_generate-more')}
                typeOfCount={''}
                onClick={() => {
                  getSuggestions(textToAnalyze)
                }}
              >
                <Add
                  key={nextId()}
                  style={{ fill: colors.colorIcons, height: 24 }}/>
              </ButtonWithPop>
              <p style={{
                color: colors.colorPrimary500,
              }}>{t('analyse_magic_wand_footer-tip')}</p>
            </div>
          }
        </div>
        {loading &&
          <div className={`mx-auto my-auto`}
               style={{ borderColor: borderColors.borderPrimary100 }}>
            <div className={`d-flex justify-content-center align-items-center`}>
              <div style={{ marginTop: '40px', }}><img
                alt={t('analyse_magic_wand_loading')} src={ComBotGray} width={30}
                className={style.android}/></div>
              <div
                style={{ marginLeft: '20px', color: colors.colorText }}>{t('analyse_magic_wand_loading')} <b>{percent} %</b>
              </div>
            </div>
          </div>
        }
      </div>
    </Modal>
  )
}